import styled from 'styled-components';
import DialogTitle from "@mui/material/DialogTitle";
import { DialogContent } from '@mui/material';
import { colors, focusRingColor } from '../../utils';

export const DialogContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap; 24px;
    padding-top: 20px;
    padding-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0px 0px 9.3px 0px #3B3B3B1C;
    background-color: #fff;
`;

export const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .close-icon {
    cursor: pointer;
  }
`;

export const StyledDialogContent = styled(DialogContent)`
  padding: 20px 0 20px 0 !important;
  display: flex;
  gap: 16px;
  flex-direction: column;
`

export const Title = styled.div`
  font-weight: 700;
  color: #0F0F0F;
  font-size: 20px;
  font-family: "DM Sans", sans-serif;
`

export const CardItem = styled.div`
    display: flex;
    padding: 16px;
    margin-left: 20px;
    margin-right: 20px;
    gap: 16px;
    border-radius: 8px;
    border: ${({ isDefaultCard }) => (isDefaultCard ? `1px solid ${colors.PrimaryPurple500}` : "1px solid #E1E1E1")};
`

export const PaymentMethodItem = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const CardDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CardLogo = styled.img`
  width: 40px;
  height: auto;
`;

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardNumber = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  font-family: "DM Sans", sans-serif;
  color: #0F0F0F;
`

export const CardExpiry = styled.span`
  font-size: 12px;
  color: #565556;
  line-height: 20px;
  font-family: "DM Sans", sans-serif;
  font-weight: 500;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`

export const DefaultButton = styled.button`
  background-color: #EFE9FE;
  color: #9B5AF8;
  padding: 4px;
  border-radius: 4px;
  cursor: default;
  border: none;
`;

export const SetDefaultText = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #9B5AF8;
  font-family: "DM Sans", sans-serif;
  cursor: pointer;
`

export const ExpireButton = styled.div`
  background-color: #FCE5E0;
  padding: 4px;
  border-radius: 4px;
  color: #E54D2E;
`

export const Footer = styled.div`
  display: flex;
  align-self: flex-end;
  align-items: flex-end;
  margin-top: 5px;
  margin-right: 20px;
`;

export const Separator = styled.div`
    border: 1px solid #E1E1E1;
    width: 100%;
`

export const InternalHeading = styled.div`
    font-size: 20px;
    line-height: 20px;
    font-weight: 700;
    font-family: "DM Sans", sans-serif;
    color: #123051;
    text-align: center;
`

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 20px;
`

export const BottomSeparator = styled.div`
  margin-top: 8px;
`

export const DeleteButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 4px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: #565556;
  transition: background-color 0.15s ease;

  &:hover:not(:disabled) {
    background-color: #FCE5E0;
  }

  &:focus-visible {
    outline: 2px solid ${focusRingColor};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }

  img {
    display: block;
    pointer-events: none;
  }
`

export const ConfirmContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  background-color: #fff;
  border-radius: 8px;
`

export const ConfirmTitle = styled.div`
  font-family: "DM Sans", sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #0F0F0F;
`

export const ConfirmText = styled.div`
  font-family: "DM Sans", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #565556;
`

export const ConfirmCardNumber = styled.span`
  font-weight: 700;
  color: #0F0F0F;
`

export const ConfirmFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
`
